import script from "./AddBalance.vue?vue&type=script&lang=ts&setup=true"
export * from "./AddBalance.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__